import React from 'react';
import PropTypes from 'prop-types';
import { FlexboxGrid, ButtonToolbar } from 'rsuite';
import { reduce, isArray, isNull, isEmpty } from 'lodash/fp';
import { Context } from '../../../constants/download-request';
import {
  VISIT_ON_FIELD,
  SettingsByField
} from '../../../constants/visit/AssocVisitFields';
import DownloadRequestExportButton from '../../DownloadRequestExportButton';
import { formatDateRange } from '../../../helpers/dates';

const reduceWithKey = reduce.convert({ cap: false });

const parseArrayValue = (field, value) => {
  if (!value || isEmpty(value)) return '';
  if (field === VISIT_ON_FIELD) {
    return formatDateRange(value).join(' - ');
  }
  return value.join(', ');
};

const composeExportHeader = reduceWithKey((headerData, value, field) => {
  if (value === '' || isNull(value)) return headerData;

  return [
    ...headerData,
    [
      {
        value: SettingsByField[field].label,
        style: { font: { bold: true } }
      },
      { value: isArray(value) ? parseArrayValue(field, value) : value }
    ]
  ];
}, []);

const composeExportColumnLabels = columns => ({
  source: 'Source',
  visit_on: 'Visit On',
  ...reduce(
    (columnLabel, column) => ({
      ...columnLabel,
      [column.split('.')[1]]: SettingsByField[column].label
    }),
    {},
    columns
  )
});

function ResultHeader({ searchQuery }) {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <ButtonToolbar style={{ textAlign: 'right' }}>
          <DownloadRequestExportButton
            name="Visit History"
            context={Context.VISIT_HISTORY}
            query={searchQuery}
            exportHeader={composeExportHeader(searchQuery.filter)}
            exportColumnLabels={composeExportColumnLabels(searchQuery.columns)}
          />
        </ButtonToolbar>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}

ResultHeader.propTypes = {
  searchQuery: PropTypes.shape({
    filter: PropTypes.shape({}).isRequired,
    columns: PropTypes.arrayOf(PropTypes.string).isRequired,
    includeAssocVisits: PropTypes.number.isRequired
  }).isRequired
};

export default ResultHeader;
